import { useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { getContactSchema } from '@/app/components/common/forms/ContactForm/schema';
import { useModal } from '@/context/ModalContext';
import { getAllUtmParams } from '@/lib/utmTracking';

export const useContactForm = (config) => {
  const phoneFormatRef = useRef('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { dataFields, isOpen } = useModal();

  const budgetOptions = useMemo(() => {
    if (!config?.budgetVariants) return [];
    return config.budgetVariants
      .split('\n')
      .map((item) => item.trim())
      .filter(Boolean);
  }, [config?.budgetVariants]);

  const contactMethods = useMemo(() => {
    if (!config?.contactMethods) return [];
    return config.contactMethods
      .split('\n')
      .map((item) => item.trim())
      .filter(Boolean);
  }, [config?.contactMethods]);

  const [utmParams] = useState(() => {
    if (typeof window !== 'undefined') {
      return getAllUtmParams();
    }
    return {};
  });

  const {
    handleSubmit,
    control,
    setValue,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(getContactSchema(config?.formFields?.fields || [])),
    defaultValues: {
      budget: '',
      contactMethod: contactMethods[0] || '',
      pageName: typeof window !== 'undefined' ? document.title : '',
      pageUrl: typeof window !== 'undefined' ? window.location.href : '',
      ...utmParams,
    },
    context: {
      phoneFormatRef,
    },
  });

  useEffect(() => {
    if (budgetOptions.length > 0) {
      setValue('budget', budgetOptions[0]);
    }
  }, [budgetOptions, setValue]);

  useEffect(() => {
    if (dataFields) {
      Object.entries(dataFields).forEach(([key, value]) => {
        setValue(key, value);
      });
    }
  }, [dataFields, setValue]);

  useEffect(() => {
    if (isOpen) {
      reset();
      setIsSubmitted(false);
    }
  }, [isOpen, reset]);

  return {
    handleSubmit,
    control,
    errors,
    phoneFormatRef,
    setIsSubmitted,
    isSubmitted,
    budgetOptions,
    contactMethods,
    getValues,
    setValue,
  };
};
